<template>
  <div class="mb-6">
    <div class="sm:hidden">
      <label for="tabs" class="sr-only">Select a tab</label>
      <NtSelect label="Tab" v-model="mobileSelected" :options="filteredTabs" />
    </div>
    <div class="hidden sm:block">
      <div class="border-b border-neutral-200 dark:border-neutral-700">
        <nav class="-mb-px flex overflow-x-auto" aria-label="Tabs">
          <RouterLink
            v-for="tab in filteredTabs"
            :key="tab.id"
            :to="{ name: `page.${tab.id}` }"
            :class="[
              tab.id === selected
                ? 'border-accent-500 text-accent-600'
                : 'border-transparent text-neutral-500 dark:text-neutral-400 hover:border-neutral-300 dark:hover:border-neutral-400 hover:text-neutral-700 dark:hover:text-neutral-300',
              'group inline-flex items-center border-b-2 py-4 px-3 text-sm font-medium whitespace-nowrap'
            ]"
            :aria-current="tab.id === selected ? 'page' : undefined">
            <i
              :class="[
                tab.icon,
                tab.id === selected
                  ? 'text-accent-500'
                  : 'text-neutral-400 dark:text-neutral-500 group-hover:text-neutral-500 dark:group-hover:text-neutral-400',
                '-ml-0.5 mr-2 fa-sharp text-lg'
              ]"
              aria-hidden="true"></i>
            <span>{{ tab.name }}</span>
            <!-- <i
              v-if="$helpers.pageIsCallToAction(tab.id, true)"
              class="fa-sharp fa-circle-small text-red-500 ml-2"
              aria-hidden="true"></i> -->
          </RouterLink>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router'
import NtSelect from '../forms/NtSelect.vue'
import { mapState } from 'pinia'
import { useSystemStore } from '@/stores/system'

export default {
  components: { RouterLink, NtSelect },
  props: {
    tabs: {
      type: Array,
      required: true
    },
    selected: {
      required: true
    }
  },
  data() {
    return {
      mobileSelected: this.selected
    }
  },
  computed: {
    ...mapState(useSystemStore, ['navPermissions']),
    filteredTabs() {
      return this.tabs.filter((t) => !t.nav_permission || this.navPermissions.includes(t.nav_permission))
    }
  },
  watch: {
    selected(id) {
      this.mobileSelected = id
    },
    mobileSelected(id) {
      if (!id) {
        return
      }
      this.$router.push({ name: `page.${id}` })
    }
  }
}
</script>
